import handleCallback from "../helper/APICallback";
import APIService from "./apiService";
import AuthService from "./authService";

const API = AuthService.getRemoteURL();

const LogoutService = {
  postLogout(data) {
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          url: `${API}/api/v2/POS/authentication/terminal-logout`,
          method: "POST",
          data: JSON.stringify(data),
        },
        handleCallback(resolve, reject)
      );
    });
  },
};
export default LogoutService;
